var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title-section"},[_c('h5',[_vm._v("A PUBLICATION FROM BROAD INSTITUTE OF MIT AND HARVARD")]),_c('h5',[_vm._v("Last updated "+_vm._s(_vm.dateUpdated))]),_c('h1',[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }